import { displayMessage, closeToastByTaskId } from "../alert/messageFunc.js";
import { translate } from "../helpers/translations.js";
import { showRecaptchaChallenge, closeRecaptchaModal } from "./grecaptcha.js";
import { prepareTotpQrHtml } from "../helpers/totpQr.js";
import { withCsrfToken } from "../helpers/csrf.js";
import { toSVG } from "../helpers/toSVG.js";

// Переменная для хранения данных о текущей попытке входа
let loginAttemptData = null;

// 1. Функция отправки данных на сервер (AJAX)
async function sendLoginRequestToServer(data) {
    displayMessage(translate('Processing...', 'warning'), 'warning', '', 2);
    try {
        const response = await fetch(data.originalAction, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(withCsrfToken(data.originalAction, data))
        });

        const result = await response.json();

        // Пароль принят, но вход не завершён: у пользователя включена 2FA.
        // Контракт ответа описан в docs/2fa-backend-tasks.md.
        if (result.requires_2fa) {
            if (typeof result.content_html !== 'string' || !result.content_html.trim()) {
                console.error('requires_2fa without content_html');
                closeRecaptchaModal();
                const loginModal = document.querySelector('.modal[data-alert="login"]');
                if (loginModal) loginModal.classList.add('open', 'show');
                displayMessage(translate('Login error. Please try again.'), 'error', translate('Error'));
                return;
            }

            // Prepare and insert the next step before discarding the current one.
            document.body.insertAdjacentHTML('beforeend', prepareTotpQrHtml(result.content_html));
            toSVG();
            closeRecaptchaModal();
            loginAttemptData = null;

            const loginModal = document.querySelector('.modal[data-alert="login"]');
            if (loginModal) loginModal.classList.remove('open');

            // поля кода подхватит helpers/otpInput.js, отправку сделает helpers/js_form.js
            return;
        }

        if (response.ok && result.success) {
            if (result.message) {
                displayMessage(result.message, 'success', translate('Success'));
            }
            closeRecaptchaModal(); // Закрыть модальное окно reCAPTCHA
            loginAttemptData = null; // Сбросить данные после успеха

            if (result.redirectUrl) {
                displayMessage(translate('Redirecting...', 'warning'));
                window.location.href = result.redirectUrl;
            } else {
                window.location.reload(); // Общая перезагрузка страницы
            }
        } else {
            console.error('Login request rejected by server');
            const errorMessage = result.message || translate('Login error. Please try again.');
            displayMessage(errorMessage, 'error', translate('Error'));

            if (data.type === 'email' /* && result.status === 2 (если есть такой статус) */) {
                // Если ошибка специфична для email (например, неверный пароль, но капча пройдена)
                // И нужно вернуть пользователя в окно логина, а не капчи.
                closeRecaptchaModal();
                const loginModal = document.querySelector('.modal[data-alert="login"]');
                if (loginModal) {
                    loginModal.classList.add('open', 'show');
                }
            }
             // Не сбрасываем loginAttemptData здесь, чтобы пользователь мог попробовать снова, если это ошибка капчи.
             // Если же ошибка - неверный пароль, то loginAttemptData будет перезаписан при новой попытке.
        }
    } catch (error) {
        
        console.error('Login network error or invalid JSON response');
        const networkErrorMsg = translate('Network error occurred. Please try again later.');
        displayMessage(networkErrorMsg, 'error', translate('Error'));
        // loginAttemptData не сбрасываем, чтобы дать возможность повторить.
    }
}

// 2. Обработчики для инициации логина и показа reCAPTCHA
function initiateLoginProcess(attemptData) {
    loginAttemptData = attemptData; // Сохраняем данные попытки

    // Закрываем основное модальное окно логина перед открытием reCAPTCHA
    const loginModal = document.querySelector('.modal[data-alert="login"]');
    if (loginModal) {
        loginModal.classList.remove('open');
    }

    showRecaptchaChallenge({
        onSuccess: (token) => {
            if (loginAttemptData) {
                loginAttemptData.recaptchaToken = token;
                sendLoginRequestToServer(loginAttemptData);
            } else {
                console.error("Login attempt data is missing after reCAPTCHA success!");
                displayMessage(translate('Internal error occurred. Please try again.'), 'error', translate('Error'));
            }
        },
        onExpired: () => {
            // Сообщение уже отображается в grecaptcha.js
            // Можно добавить логику сброса loginAttemptData, если это необходимо
            // loginAttemptData = null;
        },
        onError: (errorMsg) => {
            // Сообщение уже отображается в grecaptcha.js
            console.error("reCAPTCHA challenge error:", errorMsg);
            // Можно добавить логику сброса loginAttemptData и возврата в модалку логина
            // loginAttemptData = null;
            // if (loginModal) loginModal.classList.add('open');
        },
        onCancel: () => {
            console.log("reCAPTCHA challenge cancelled by user.");
            loginAttemptData = null; // Сбросить данные, если пользователь закрыл reCAPTCHA
            // Возвращаем пользователя в модальное окно логина
            if (loginModal) {
                loginModal.classList.add('open', 'show');
            }
        }
    });
}

// 3. Настройка обработчиков событий для кнопок входа
document.addEventListener('DOMContentLoaded', () => {
    const mainLoginModal = document.querySelector('.modal[data-alert="login"]');
    if (!mainLoginModal) {
        console.warn('Main login modal (.modal[data-alert="login"]) not found. Login handlers not attached.');
        return;
    }

    // Кнопки социальных сетей
    const socialLoginButtons = mainLoginModal.querySelectorAll('.profile__info-sign-elem');
    socialLoginButtons.forEach(button => {
        button.addEventListener('click', function(event) {
            event.preventDefault();

            if (typeof ym === 'function' && button.getAttribute('onclick')) {
                const ymCallMatch = button.getAttribute('onclick').match(/ym\(([^)]+)\)/);
                if (ymCallMatch && ymCallMatch[1]) {
                    try {
                        const params = ymCallMatch[1].split(',').map(p => p.trim().replace(/^['"]|['"]$/g, ''));
                        if (params.length >= 2) {
                             ym(parseInt(params[0]), params[1], params.slice(2).join(', '));
                        }
                    } catch (e) { console.warn("Can't ym() onclick for social button:", e); }
                }
            }

            const form = button.closest('form');
            if (!form) {
                console.error('Form for social network button not found');
                return;
            }
            const actionUrl = form.getAttribute('action');
            let loginType = 'unknown_social';

            const urlParams = new URLSearchParams(actionUrl.split('?')[1]);
            if (urlParams.has('login')) {
                loginType = urlParams.get('login').toLowerCase();
            } else {
                const boldText = button.querySelector('b');
                if (boldText) loginType = boldText.textContent.trim().toLowerCase();
            }

            initiateLoginProcess({
                type: loginType,
                originalAction: actionUrl
            });
        });
    });

    // Кнопка входа через Email/Пароль
    const emailLoginFormDiv = mainLoginModal.querySelector('.form-auth[action*="login=mail"]');
    if (emailLoginFormDiv) {
        const emailLoginButton = emailLoginFormDiv.querySelector('button[name="login"]');
        const emailInput = emailLoginFormDiv.querySelector('input[name="mail"]');
        const passwordInput = emailLoginFormDiv.querySelector('input[name="password"]');

        if (emailLoginButton && emailInput && passwordInput) {
            emailLoginButton.addEventListener('click', function(event) {
                event.preventDefault();

                if (typeof ym === 'function' && emailLoginButton.getAttribute('onclick')) {
                    const ymCallMatch = emailLoginButton.getAttribute('onclick').match(/ym\(([^)]+)\)/);
                    if (ymCallMatch && ymCallMatch[1]) {
                        try {
                            const params = ymCallMatch[1].split(',').map(p => p.trim().replace(/^['"]|['"]$/g, ''));
                             if (params.length >= 2) {
                                ym(parseInt(params[0]), params[1], params.slice(2).join(', '));
                            }
                        } catch (e) { console.warn("Can't ym() onclick for email button:", e); }
                    }
                }
                const originalAction = emailLoginFormDiv.getAttribute('action');
                initiateLoginProcess({
                    type: 'email',
                    email: emailInput.value,
                    password: passwordInput.value,
                    originalAction: originalAction
                });
            });
        } else {
            console.warn('Not all email/password form elements found inside .form-auth[action*="login=mail"].');
        }
    } else {
        console.warn('Email/password form container (.form-auth[action*="login=mail"]) not found.');
    }

    // Интервал для триггера событий input
    setInterval(() => {
        const inputsToTrigger = document.querySelectorAll('.valid-email, .valid-pass');
        inputsToTrigger.forEach(input => {
            const event = new Event('input', { bubbles: true, cancelable: true });
            input.dispatchEvent(event);
        });
    }, 500);
});
